<template>
  <div class="ProductsAndService">
    <div style="position: relative">
      <img
        src="../../assets/detail-banner.jpg"
        style="height: 200px; width: 100%"
        alt="banner"
      />
      <h1 class="banner-text">Products and Service</h1>
    </div>
    <el-row>
      <el-col
        :xs="{ span: 22, offset: 1 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 22, offset: 1 }"
        :lg="{ span: 20, offset: 2 }"
        :xl="{ span: 16, offset: 4 }"
      >
        <ul>
          <li
            v-for="(item, index) in services"
            :key="item.itemId"
            class="products-item"
            :class="{
              column: isMobile,
              reverse: index % 2 !== 0 && !isMobile,
              under: index != 0,
            }"
            @click="goTo(item)"
          >
            <div class="text">
              <h2>{{ item.title }}</h2>
              <p>{{ item.description }}</p>
              <i v-if="!isMobile" class="el-icon-d-arrow-right more" />
            </div>
            <div class="divider"></div>
            <div class="image">
              <img :src="item.image" :alt="item.title" />
            </div>
          </li>
        </ul>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "ProductsAndService",
  props: {},
  data() {
    return {
      services: [
        {
          title: "Mold Custom",
          description:
            "Based on 30 years of experience in mold usage and management, Haier started from mold project, mold procurement, mold design, mold processing and assembling, to the whole process of customized service for the enterprise of mold delivery. HiMo Industry mold technology guarantees the final delivery to the user's optimal mold quality, the lowest cost by mould manufacturing multi-node review, mold project schedule visualization management solution service.\n" +
            "\nPlan Advantage\n" +
            "1. Open and transparent mould procurement process and low cost.\n" +
            "2. Visualized project management of mold manufacturing process.\n" +
            "3. Mold professional review to reduce mold maintenance rate.\n" +
            "4. Experienced supplier entry and exit management.\n",
          image: require("../../assets/images/services/mold.jpg"),
          itemId: "1",
        },
        {
          title: "3D Printing",
          description:
            "HiMo Industry comprehensive 3D printing solutions are widely used in various industries, and are developing towards the direction of faster speed, higher accuracy, better performance and more reliable quality. HiMo Industry COSMOPlat has become a powerful scientific and technological force, comprehensively promoting the change and innovation of the manufacturing industry.\n" +
            "\n" +
            "3D printing technology can effectively shorten the research and development cycle of new products, reduce research and development costs, and greatly improve the success rate of research and development. Printing materials cover metals, photosensitive resins, nylon, etc.. We provide product development and personalized customization service support for domestic and foreign users.\n",
          image: require("../../assets/images/services/printing.jpg"),
          itemId: "2",
        },
        {
          title: "Mold Accessories",
          description:
            "HiMo Industry mould parts are widely used in all kinds of stamping mould, plastic mould, automobile, electrical and aviation, automation equipment and other manufacturing fields. We can customize all kinds of mould parts, a complete range, and short supply cycle.",
          image: require("../../assets/images/services/accessories.jpg"),
          itemId: "3",
        },
        {
          title: "Equipment Supply",
          description:
            "Mold related equipment supporting, integration, covering multiple industries, to provide customers with high quality equipment and services.",
          image: require("../../assets/images/services/equipment.jpg"),
          itemId: "4",
          url: "/equipment-supply",
        },
        {
          title: "After-Sale Service",
          description:
            "Through collaborative after-sale service network in overseas manufacturing centers, HiMo Industry can provide users with timely and accurate seamless connection, mold emergency troubleshooting and mold routine maintenance services. By mold interconnection application, the maintenance engineer can access the problem mold drawings and mold production history with one click, and can deeply communicate and cooperate with the original mold design engineer to realize the remote diagnosis and repair of the problem mold, which can help customers quickly solve after-sale problems with satisfaction.",
          image: require("../../assets/images/services/after-sale.jpg"),
          itemId: "5",
        },
      ],
    };
  },

  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  methods: {
    goTo(item) {
      this.$router.push(
        item.url ||
          `/products-list/${item.title
            .split(" ")
            .map((it) => it.toLowerCase())
            .join("-")}/${item.itemId}`
      );
    },
  },
};
</script>

<style src="./_ProductsAndService.scss" lang="scss" />
